<template>
  <Card theme="border" class="purchase-signing" :class="{ 'purchase-signing--active': current }">
    <template #header>
      <h1>{{ $t('purchaseSigning') }}</h1>
    </template>
    <template #default>
      <Loader
        :value="promise"
        theme="default"
        :message="$t('loading', { resource: $t('purchaseContract').toLowerCase() })"
      >
        <div class="row center wrap g-1">
          <ApplicantCard v-for="(item, index) in signers" :value="item" theme="border" :key="index">
            <template #footer>
              <ButtonComponent
                :label="$t(!item.signUrl ? 'signed' : 'sign')"
                :theme="!item.signUrl ? 'success' : 'primary'"
                :icon="!item.signUrl ? 'check-circle' : ['fal', 'angle-right']"
                @click="startSigning(item)"
              />
            </template>
          </ApplicantCard>
        </div>
      </Loader>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState } from 'vuex'

import Card from '@/components/Card'
import ApplicantCard from '@/components/Applicant'
import { Clone, GetJwtPayload } from '@/utils'
import { Initials } from '@/filters'

const meta = {
  order: 1,
  id: 'signing',
  label: i18n.tc('purchaseSigning'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    signers: {
      handler(val) {
        if (this.$route.query['idfy-jwt']) return
        if (val && val.length === 1) return this.startSigning(val[0])
      },
      immediate: true,
    },
    allSigned: {
      handler(val) {
        if (!val) return
        this.$emit('update:isValid', true)
        this.$emit('completed')
        return this.$emit('next')
      },
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      current: null,
    }
  },
  computed: {
    ...mapState('Residential', ['item']),
    signers() {
      let res = []
      if (!this.value) return []

      res.push(this.value.data.applicant)
      if (this.$path('value.data.hasCoApplicant')) res.push(this.value.data.coApplicant)

      return res
    },
    allSigned() {
      if (!this.signers.length) return false

      return this.signers.every(s => !s.signUrl)
    },
  },
  methods: {
    startSigning(signer) {
      if (!signer.signUrl) return
      this.current = signer

      window.location.href = signer.signUrl
    },
  },
  created() {
    if (!this.$route.query['idfy-jwt']) return

    const token = GetJwtPayload(this.$route.query['idfy-jwt'])
    this.$router.replace({ query: { ...this.$route.query, ['idfy-jwt']: undefined } })
    if (!token.SignSuccess) return

    const signer = this.signers.find(s => [s.email, s.signerId].includes(token.ExternalSignerId))
    if (!signer) return this.$emit('next')

    this.$set(signer, 'signed', true)
  },
  filters: {
    Initials,
  },
  components: {
    Card,
    ApplicantCard,
  },
}
</script>

<style lang="scss">
.purchase-signing {
  margin: 0 auto;

  &--active {
    .card__content {
      padding: 0;
    }
  }

  iframe {
    width: 100%;
    height: 800px;
  }

  .card__header {
    min-height: 125px;
  }

  h1 {
    margin: 0;
  }
}
</style>
